import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetProjectRegionListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    columnChooser: ColumnChooserModel[] | undefined
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    selectedCountry: CustomSingleSelectModel | undefined
    selectedCounty: CustomSingleSelectModel | undefined
    selectedDistrict: CustomSingleSelectModel | undefined
    selectedNeighborhood: CustomSingleSelectModel | undefined
    selectedProject: CustomSingleSelectModel | undefined
    selectedCarryTypes: CustomMultiSelectModel[]
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetProjectRegionListPagingAndFilterRequest: GetProjectRegionListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnChooser: undefined,
    selectedCountry: undefined,
    selectedCounty: undefined,
    selectedDistrict: undefined,
    selectedNeighborhood: undefined,
    selectedProject: undefined,
    selectedCarryTypes: [],
    columnFilters: []
}